const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const uuid = value => {
  if (! value || (String(value) === "undefined" && ! String(value).match(uuidRegex))) {
    return value;
  }

  return String(value);
}

export const isValidUuid = value => {
  return String(value).match(uuidRegex) !== null;
}
